import { cva, type VariantProps } from 'class-variance-authority';

export const bannerVariants = cva('flex flex-wrap items-center gap-x-5 gap-y-3 rounded-tile', {
  variants: {
    tone: {
      warn: 'bg-accent-soft',
      bad: 'bg-danger-soft',
      info: 'bg-info-soft',
      ok: 'bg-ok-soft',
    },
    size: {
      md: 'px-4.5 py-3.5',
      compact: 'px-3.5 py-3',
      small: 'px-3.5 py-2.5 text-meta',
    },
  },
  defaultVariants: { tone: 'info', size: 'md' },
});

export type BannerVariants = VariantProps<typeof bannerVariants>;
